import { GenericStatusEnum } from '@e-socna/data-layer';

import { ThirdParties } from '../../../components/ThirdParties';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

interface Props {
  readonly isInternal: boolean;
}

export const DisabledTabPanel = ({ isInternal }: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  return (
    <ThirdParties
      initialGridState={initialGridState}
      isInternal={isInternal}
      status={GenericStatusEnum.Disabled}
    />
  );
};
